var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('favorites-state-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var favoritesCount = ref.favoritesCount;
return [(!favoritesCount)?_c('span',[_vm._v("У вас нет товаров в Избранном")]):_c('span',[_vm._v(_vm._s(favoritesCount)+_vm._s(_vm.getPluralString(favoritesCount))+" в Избранном")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }